"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllowanceType = void 0;
/**
 * Allowance
 */
var AllowanceType;
(function (AllowanceType) {
    AllowanceType["Wardrobe_Fee"] = "Wardrobe Fee";
    AllowanceType["Wardrobe_FeeEvePeriod"] = "Wardrobe Fee - Eve/Period";
    AllowanceType["LocationMeal_Breakfast"] = "Breakfast";
    AllowanceType["LocationMeal_Lunch"] = "Lunch";
    AllowanceType["LocationMeal_Dinnner"] = "Dinnner";
    AllowanceType["Travel_ExtrasRoundTrip"] = "Extras - Round Trip";
    AllowanceType["Travel_PerMileOutsideStudioZone"] = "Per mile (outside studio zone)";
    AllowanceType["Travel_OCPPerDiem"] = "OCP travel per diem";
    AllowanceType["Props_AutomobileTrailerMotorcycle"] = "Automobile, Trailer or Motorcycle";
    AllowanceType["Props_SkatesSkateBoards"] = "Skates and Skate Boards";
    AllowanceType["Props_Bicycle"] = "Bicycle";
    AllowanceType["Props_Moped"] = "Moped";
    AllowanceType["Props_Camera"] = "Camera";
    AllowanceType["Props_Pet"] = "Pet";
    AllowanceType["Props_LuggageEachPiece"] = "Luggage (each piece)";
    AllowanceType["Props_GolfClubsAndBag"] = "Golf Clubs & Bag";
    AllowanceType["Props_TennisRacquet"] = "Tennis Racquet";
    AllowanceType["Props_Skis"] = "Skis";
    AllowanceType["Props_BinocularsOperaGlasses"] = "Binoculars or Opera Glasses";
    AllowanceType["Props_LargePortableRadios"] = "Large Portable Radios";
    AllowanceType["Props_BooksEach"] = "Books (each)";
    AllowanceType["Props_LaptopCellPhonePDAiPodMP3Player"] = "Laptop, Cell Phone/PDA, iPod/MP3 Player";
    AllowanceType["Props_StandardOpeningOrClosing"] = "Standard Opening or Closing";
    AllowanceType["Props_WetSnowmokeDustWork"] = "Wet, Snow, Smoke, & Dust Work";
    AllowanceType["Props_BodyMUSkullCapHairGoodsHaircuts"] = "Body MU, Skull Cap, Hair Goods, Haircuts";
})(AllowanceType || (exports.AllowanceType = AllowanceType = {}));
//# sourceMappingURL=allowance-types.js.map